import GetQueryParam from '../util/get-query-param';

class StyleDetailController {
    constructor() {
        let tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        this.player = null;
        this.playerbottom = null;
        window.onYouTubeIframeAPIReady = () => {
            this.player = new YT.Player('js-popup__movie', {
                // width: w,
                // height: h,
                videoId: $('#js-style-detail__movie-btn').data('yid'),
            });
            this.playerbottom = new YT.Player('js-popup__moviebottom', {
                // width: w,
                // height: h,
                videoId: $('#js-style-detail__moviebottom-btn').data('yid'),
            });
        };

        this.setPopupMovie();
        this.setPopupMovieBottom();
        this.setFigurePopupSlider();
        this.setSPPickupSlider();
        this.removeCurrentfromOtherSlide();
        this.setOtherSlider();

        let q = new GetQueryParam();

        if (q.movie) {
            setTimeout(()=>{
                $('#js-style-detail__movie-btn').trigger('click');
            }, 2500);
        }
        if (q.moviebottom) {
            setTimeout(()=>{
                $('#js-style-detail__moviebottom-btn').trigger('click');
            }, 2500);
        }
        if (q.figure) {
            // console.log(q);
            setTimeout(()=>{
                $('.style-detail__figure-items a').eq(q.figure-1).trigger('click');
            }, 2500);
        }
    }

    setPopupMovie() {
        let $link = $('#js-style-detail__movie-btn');
        let $pop = $('.style-detail__movie-popup');
        let _this = this;
        $link.on('click', function (e) {
            e.preventDefault();
            $pop.toggleClass('is-open');
            _this.player.playVideo();
        });

        $pop.on('click', function (e) {
            e.preventDefault();
            // console.log(e.currentTarget);
            if ($(e.target).hasClass('is-open')) {
                $pop.removeClass('is-open');
                _this.player.pauseVideo();
            }
        });
        $('.common-popup__close').on('click', function (e) {
            e.preventDefault();
            $pop.removeClass('is-open');
            _this.player.pauseVideo();
        });
    }

    setPopupMovieBottom() {
        let $link = $('#js-style-detail__moviebottom-btn');
        let $pop = $('.style-detail__moviebottom-popup');
        let _this = this;
        $link.on('click', function (e) {
            e.preventDefault();
            $pop.toggleClass('is-open');
            _this.playerbottom.playVideo();
        });

        $pop.on('click', function (e) {
            e.preventDefault();
            // console.log(e.currentTarget);
            if ($(e.target).hasClass('is-open')) {
                $pop.removeClass('is-open');
                _this.playerbottom.pauseVideo();
            }
        });
        $('.common-popup__close').on('click', function (e) {
            e.preventDefault();
            $pop.removeClass('is-open');
            // console.log(_this.playerbotto);
            if(_this.playerbottom === void 0) {
                _this.playerbottom.pauseVideo();
            }
            
        });
    }

    setFigurePopupSlider() {
        let $items = $('.style-detail__figure-items .swiper-slide').clone(false, false);
        $('#js-style-detail__figure-popup-slider .swiper-wrapper').append($items.clone(false, false));
        // $('#js-style-detail__figure-popup-thumb .swiper-wrapper').append($items.clone(false, false));
        let thumbOptions = {
            spaceBetween: window.UA.isSP ? 4 : 12,
            slidesPerView: window.UA.isSP ? 'auto' : 'auto',
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: false,
            preventClicks: false,
            preventClicksPropagation: false,
            preventInteractionOnTransition: false,
            // passiveListeners: false,
            // allowTouchMove: window.UA.isSP ? true : false,
            // on: {
            //     click: function (swiper) {
            //         console.log(swiper.clickedIndex);
            //     }
            // }
        };
        let thumbSlider = new Swiper(
            '#js-style-detail__figure-popup-thumb',
            thumbOptions
        );
        let options = {
            // loop: true,
            // loopAdditionalSlides: 1,
            // loopedSlides: 5,
            // freeMode: true,
            // autoplay: {
            //     delay: 5000,
            //     disableOnInteraction: false,
            // },
            loopFillGroupWithBlank: false,
            // updateOnWindowResize: false,
            // width: (window.UA.isSP)? 210: 420,
            // centeredSlides: false,
            // centerInsufficientSlides: true,
            // width: (window.UA.isSP)? 190: 500,
            // spaceBetween:  (window.UA.isSP)? 24: 40,
            slidesPerView: 1,
            // slidesPerGroup: 1,
            navigation: {
                nextEl: '.style-detail__figure-popup-slider-next',
                prevEl: '.style-detail__figure-popup-slider-prev',
            },
            // scrollbar: {
            //     el: '#js-home-voice__slider-bar',
            //     // hide: true,
            //     draggable: false,
            // },
            touchAngle: 20,
            speed: 800,
            // pagination: {
            // el: '#js-mainvisual__slider-pagination',
            // clickable: true,
            // renderBullet: function (index, className) {
            //     return `<div class="mainvisual__slider-pagination-bullet"><svg width="44" height="44"><circle cx="22" cy="22" r="21" /></svg><span>0${(index + 1)}</span></div>`;
            // },
            // bulletClass: 'mainvisual__slider-pagination-bullet',
            // bulletActiveClass: 'is-active'
            // },
            // effect: 'fade',
            // fadeEffect: {
            //     crossFade: true
            // },
            on: {
                // onSlideChangeEnd : (s) => {s.fixLoop();}
            },
            // thumbs: {
            //     swiper: thumbSlider,
            // },
        };

        if($items.length < 2) {
            options.centeredSlides = true;
        }
        let figureSlider = new Swiper('#js-style-detail__figure-popup-slider', options);
        // if (window.UA.isSP) {
        //     figureSlider.off('resize');
        // }

        let $link = $('.style-detail__figure-items a');
        let $pop = $('.style-detail__figure-popup');
        let $close = $('.style-detail__figure-popup-close');
        let $close2 = $('.style-detail__figure-popup-inner [data-modal2-close]');
        let _this = this;
        $link.on('click', function (e) {
            e.preventDefault();
            $pop.toggleClass('is-open');
            let slideidx = $(this).closest('.swiper-slide').index();
            // console.log(slideidx);
            figureSlider.slideTo(slideidx);
        });

        $pop.on('click', function (e) {
            e.preventDefault();
            // console.log(e.currentTarget);
            if ($(e.target).hasClass('is-open')) {
                $pop.removeClass('is-open');
            }
        });
        $close.on('click', function (e) {
            e.preventDefault();
            $pop.removeClass('is-open');
        });
        $close2.on('click', function (e) {
            e.preventDefault();
            $pop.removeClass('is-open');
        });
    }

    setSPPickupSlider() {

        let $items = $('.style-detail__pickup-items .swiper-slide').clone(false, false);
        $('#js-style-detail__pickup-slide-sp .swiper-wrapper').append($items);

        let options = {
            loop: true,
            loopAdditionalSlides: 1,
            // loopedSlides: 5,
            // freeMode: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            loopFillGroupWithBlank: false,
            // updateOnWindowResize: false,
            // width: (window.UA.isSP)? 210: 420,
            centeredSlides: false,
            // centerInsufficientSlides: true,
            // width: (this.UA.isSP)? 190: 190,
            spaceBetween:  (window.UA.isSP)? 24: 40,
            slidesPerView: 'auto',
            // slidesPerGroup: 1,
            // navigation: {
            //     nextEl: '#js-home-voice__slider-next',
            //     prevEl: '#js-home-voice__slider-prev',
            // },
            // scrollbar: {
            //     el: '#js-home-voice__slider-bar',
            //     // hide: true,
            //     draggable: false,
            // },
            touchAngle: 20,
            speed: 800,
            // pagination: {
            // el: '#js-mainvisual__slider-pagination',
            // clickable: true,
            // renderBullet: function (index, className) {
            //     return `<div class="mainvisual__slider-pagination-bullet"><svg width="44" height="44"><circle cx="22" cy="22" r="21" /></svg><span>0${(index + 1)}</span></div>`;
            // },
            // bulletClass: 'mainvisual__slider-pagination-bullet',
            // bulletActiveClass: 'is-active'
            // },
            // effect: 'fade',
            // fadeEffect: {
            //     crossFade: true
            // },
            on: {
                // onSlideChangeEnd : (s) => {s.fixLoop();}
            },
        };

        if($items.length < 2) {
            options.centeredSlides = true;
        }
        let pickupSlider = new Swiper('#js-style-detail__pickup-slide-sp', options);
        if (window.UA.isSP) {
            pickupSlider.off('resize');
        }
    }

    removeCurrentfromOtherSlide() {
        let current = $('#js-container').data('page');
        $(`#js-style-detail__other-slide .${current}`).closest('.swiper-slide').remove();
        window.slideitem = {
            otherBlanc: $(`#js-style-detail__other-slide .is-blanc2`).closest('.style-detail__other-slide-item').clone(),
            otherStella: $(`#js-style-detail__other-slide .is-stella2`).closest('.style-detail__other-slide-item').clone()
        }
        if($('#blanc').length > 0) {
            $(`#js-style-detail__other-slide .is-blanc2`).closest('.swiper-slide').remove();
            $(`#js-style-detail__other-slide .is-stella2`).closest('.swiper-slide').addClass('is-otherslide-premium');
        }
        if($('#stella').length > 0) {
            $(`#js-style-detail__other-slide .is-stella2`).closest('.swiper-slide').remove();
            $(`#js-style-detail__other-slide .is-blanc2`).closest('.swiper-slide').addClass('is-otherslide-premium');
        }
        if($('#stella').length < 1 && $('#blanc').length < 1) {
            $(`#js-style-detail__other-slide .is-blanc2`).closest('.swiper-slide').remove();
            $(`#js-style-detail__other-slide .is-stella2`).closest('.swiper-slide').remove();
        }
    }

    setOtherSlider() {
        let options = {
            loop: false,
            loopAdditionalSlides: 1,
            // loopedSlides: 5,
            // freeMode: true,
            // autoplay: {
            //     delay: 5000,
            //     disableOnInteraction: false,
            // },
            loopFillGroupWithBlank: false,
            // updateOnWindowResize: false,
            // width: (window.UA.isSP)? 210: 420,
            centeredSlides: false,
            // centerInsufficientSlides: true,
            // width: (this.UA.isSP)? 190: 190,
            spaceBetween:  (window.UA.isSP)? 24: 32,
            slidesPerView: 'auto',
            // slidesPerGroup: 1,
            navigation: {
                nextEl: '.style-detail__other-slide-next',
                prevEl: '.style-detail__other-slide-prev',
            },
            scrollbar: {
                el: '.style-detail__other-slide-bar',
                // hide: true,
                draggable: false,
            },
            touchAngle: 20,
            speed: 800,
            // pagination: {
            // el: '#js-mainvisual__slider-pagination',
            // clickable: true,
            // renderBullet: function (index, className) {
            //     return `<div class="mainvisual__slider-pagination-bullet"><svg width="44" height="44"><circle cx="22" cy="22" r="21" /></svg><span>0${(index + 1)}</span></div>`;
            // },
            // bulletClass: 'mainvisual__slider-pagination-bullet',
            // bulletActiveClass: 'is-active'
            // },
            // effect: 'fade',
            // fadeEffect: {
            //     crossFade: true
            // },
            on: {
                // onSlideChangeEnd : (s) => {s.fixLoop();}
            },
        };

        let otherSlider = new Swiper('#js-style-detail__other-slide', options);
        if (window.UA.isSP) {
            otherSlider.off('resize');
        }
        $('.style-detail__other-slide-next').on('click', () => {
            // console.log(voiceSlider.isEnd);
            // if (otherSlider.isEnd === true) {
            //     otherSlider.slideTo(0);
            // }
        });
    }
}

export default StyleDetailController;
